import { FormControl, Grid, MenuItem, TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import frLocale from "date-fns/locale/pt-BR";
import React, { useEffect, useState } from "react";
import loadPeriodOptions from "./period.options";

function CustomDateFilter({ onChange }) {
  const periodOptions = loadPeriodOptions();
  const [openFilterCustom, setOpenFilterCustom] = useState(false);
  const defaultKey = periodOptions.find((elem) => elem.label === "Hoje").key;
  const [defaultPeriod, setdefaultPeriod] = useState(
    periodOptions.find((elem) => elem.default)
  );
  const [selectedDate, setSelectedDate] = useState({
    startDate: new Date(defaultPeriod.startDate),
    endDate: new Date(defaultPeriod.endDate),
  });

  const handleChangeDate = (date, name) => {
    setSelectedDate((prev) => ({ ...prev, [name]: date }));
  };

  useEffect(() => {
    if (selectedDate) {
      onChange(selectedDate.startDate, selectedDate.endDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);
  const handleInputChange = (event) => {
    const value = event.target.value;
    const filterSelected = periodOptions.find((elem) => elem.key === value);
    if (filterSelected) {
      const { key, startDate, endDate } = filterSelected;

      setOpenFilterCustom(key === 13);
      setSelectedDate({
        startDate: new Date(startDate),
        endDate: new Date(endDate),
      });
      setdefaultPeriod(filterSelected);
    }
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={frLocale}>
      <FormControl variant="filled" fullWidth size="small">
        <TextField
          size="small"
          variant="outlined"
          select
          label="Filtrar por período"
          name="tipoPedido"
          fullWidth
          defaultValue={defaultKey}
          onChange={handleInputChange}
        >
          {periodOptions.map((option) => (
            <MenuItem key={option.key} value={option.key}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        {openFilterCustom && (
          <Grid sx={{ width: "100%" }} container spacing={2} mt="1rem">
            <Grid size={{ lg: 6, md: 12, xs: 12 }}>
              <DatePicker
                label="Período inicial"
                sx={{ width: "100%" }}
                format="dd/MM/yyyy"
                value={selectedDate.startDate}
                onChange={(date) => handleChangeDate(date, "startDate")}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                  },
                }}
              />
            </Grid>
            <Grid size={{ lg: 6, md: 12, xs: 12 }}>
              <DatePicker
                label="Período final"
                format="dd/MM/yyyy"
                value={selectedDate.endDate}
                onChange={(date) => handleChangeDate(date, "endDate")}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                  },
                }}
              />
            </Grid>
          </Grid>
        )}
      </FormControl>
    </LocalizationProvider>
  );
}

export default CustomDateFilter;
